export default {
    state: {
        lastName: localStorage.getItem('lastName') === 0 ? 0 : localStorage.getItem('lastName'),
    },
    mutations: {
        setLastName(state, lastName) {
            state.lastName = lastName;
        }  
    },
    actions: {
        setLastName({commit}, lastName) {
            localStorage.setItem('lastName', lastName)
            commit('setLastName', lastName);
        }
    },
};